import { apiV2 } from './http';
import { UpdateManagedAccountRequestData } from './interfaces/managedAccount';

export function updateManagedAccount(payload: UpdateManagedAccountRequestData) {
  return apiV2.post(`contracts/managed-account/update`, payload);
}

export function disableManagedAccount(
  payload: UpdateManagedAccountRequestData,
) {
  return apiV2.post(`contracts/managed-account/disable`, payload);
}
